import { Colors } from '@tableau/icons/util/Colors';
import * as React from 'react';
import { DetailsTooltipStyles } from '../DetailsTooltipStyles';
import { EntityLink, EntityLinkProps } from './EntityLink';

export interface RelatedEntityProps {
  label: string;
  link: EntityLinkProps;
  iconString?: string;
  icon?: (props: any) => React.ReactSVGElement;
}

export const RelatedEntity = (props: RelatedEntityProps) => {
  if (props.link) {
    return (
      <div className={DetailsTooltipStyles.MetadataSmallSection} style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flexGrow: 0 }}>{props.label}</div>
        {props.icon ? (
          <span style={{ position: 'relative', left: '16px', bottom: '2px', marginRight: '12px' }}>
            {
              props.icon && props.icon({ size: 18, color: Colors.Default })
            }
          </span>
        ) : (
          <></>
        )}
        <EntityLink styleOverride={{ marginLeft: '12px' }} {...props.link} />
      </div>
    );
  } else {
    return null;
  }
};
